"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CheckboxButton = _interopRequireDefault(require("../../../Buttons/CheckboxButton"));

var _Divider = _interopRequireDefault(require("../../../IconicDisplayElements/Divider"));

var _strings = _interopRequireDefault(require("../../../../constants/strings"));

var _formatters = require("../../../../helpers/formatters");

var _CoverageSelector = require("./CoverageSelector.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CoverageSelector = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CoverageSelector, _React$PureComponent);

  var _super = _createSuper(CoverageSelector);

  function CoverageSelector() {
    var _this;

    _classCallCheck(this, CoverageSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      var coverageData = _this.props.coverageData;

      _this.props.onClick(coverageData.id);
    });

    return _this;
  }

  _createClass(CoverageSelector, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          checked = _this$props.checked,
          _this$props$coverageD = _this$props.coverageData,
          title = _this$props$coverageD.title,
          perAccident = _this$props$coverageD.perAccident,
          perEmployee = _this$props$coverageD.perEmployee,
          policyLimit = _this$props$coverageD.policyLimit,
          dataTestId = _this$props.dataTestId,
          direction = _this$props.direction;
      var safeDirection = direction === 'vertical' ? 'vertical' : 'horizontal';
      return /*#__PURE__*/_react.default.createElement(_CoverageSelector.StyledCovereageSelector, {
        className: [safeDirection === 'vertical' ? 'c-coverage-selector-vertical' : '', className].join(' '),
        "data-test-id": dataTestId
      }, /*#__PURE__*/_react.default.createElement(_CheckboxButton.default, {
        className: "c-coverage-selector-checkbox-button",
        checked: checked,
        dataTestId: "coverage-selector-checkbox-button",
        onClick: this.handleClick
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: ['c-coverage-selector-layout-container', checked ? 'c-coverage-selector-checked' : ''].join(' ')
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-coverage-selector-title-block",
        "data-test-id": "coverage-selector-title"
      }, title), /*#__PURE__*/_react.default.createElement(_Divider.default, {
        className: ['c-coverage-selector-divider', checked ? 'c-coverage-selector-checked' : ''].join(' '),
        dataTestId: "coverage-selector-divider"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-coverage-selector-coverage-container"
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-coverage-selector-incident-amount",
        "data-test-id": "coverage-selector-incident-amount"
      }, "$".concat((0, _formatters.numberShortener)(perAccident))), /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "coverage-selector-incident-amount-text"
      }, _strings.default.perIncident)), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-coverage-selector-coverage-block"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-coverage-selector-employee-amount",
        "data-test-id": "coverage-selector-employee-amount"
      }, "$".concat((0, _formatters.numberShortener)(perEmployee))), /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "coverage-selector-employee-amount-text"
      }, _strings.default.perEmployee)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-coverage-selector-policy-limit",
        "data-test-id": "coverage-selector-policy-limit"
      }, "$".concat((0, _formatters.numberShortener)(policyLimit))), /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "coverage-selector-policy-limit-text"
      }, _strings.default.policyLimit)))))));
    }
  }]);

  return CoverageSelector;
}(_react.default.PureComponent);

_defineProperty(CoverageSelector, "propTypes", {
  /** Styling hook */
  className: _propTypes.default.string,

  /** Flag for checked state */
  checked: _propTypes.default.bool.isRequired,

  /** Data model for display */
  coverageData: _propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    title: _propTypes.default.string,
    perAccident: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    policyLimit: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    perEmployee: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
  }).isRequired,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Flag for direction of flow */
  direction: _propTypes.default.oneOf([undefined, 'vertical', 'horizontal']),

  /** Click event handler */
  onClick: _propTypes.default.func.isRequired
});

_defineProperty(CoverageSelector, "defaultProps", {
  className: '',
  direction: 'horizontal'
});

var _default = CoverageSelector;
exports.default = _default;